{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCWXMediaPlayer;

{$I WEBLib.TMSFNCDefines.inc}

interface

uses
  Classes, SysUtils, StrUtils
  {$IFDEF FMXLIB}
  , System.UITypes
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.Controls
  {$ENDIF}
  {$IFNDEF WEBLIB}
  {$IFNDEF LCLLIB}
  , System.Types
  {$ENDIF}
  {$IFDEF LCLLIB}
  , Controls
  {$ENDIF}
  {$ENDIF}
  {$IFDEF WEBLIB}
  , WEBLIB.Controls, Web, Contnrs
  {$ENDIF}
  , WEBLib.TMSFNCCustomWEBControl, WEBLib.TMSFNCTypes, WEBLib.TMSFNCCustomControl,
  WEBLib.TMSFNCWXCommon;

type
  TTMSFNCWXMediaPlayerPreload = (plNone, plMetadata, plAuto);

  TTMSFNCWXMediaPlayerMediaError = (MEDIA_ERR_ABORTED, MEDIA_ERR_NETWORK, MEDIA_ERR_DECODE, MEDIA_ERR_SRC_NOT_SUPPORTED);

  TTMSFNCWXMediaPlayerMediaEvent = procedure(Sender: TObject; Val: Double) of object;
  TTMSFNCWXMediaPlayerErrorEvent = procedure(Sender: TObject; Error: TTMSFNCWXMediaPlayerMediaError) of object;

  TTMSFNCWXCustomMediaPlayer = class(TTMSFNCCustomWEBControl)
  private
    FAutoPlay: Boolean;
    FCurrentTime: Double;
    FControls: Boolean;
    FDuration: Double;
    FIsPlaying: Boolean;
    FLoop: Boolean;
    FMuted: Boolean;
    FOnPlay: TNotifyEvent;
    FOnPause: TNotifyEvent;
    FOnEnded: TNotifyEvent;
    FOnError: TTMSFNCWXMediaPlayerErrorEvent;
    FOnRateChange: TTMSFNCWXMediaPlayerMediaEvent;
    FOnVolumeChange: TTMSFNCWXMediaPlayerMediaEvent;
    FOnTimeUpdate: TTMSFNCWXMediaPlayerMediaEvent;
    FOnMetaDataLoaded: TTMSFNCWXMediaPlayerMediaEvent;
    FPlayBackRate: Double;
    FPreload: TTMSFNCWXMediaPlayerPreload;
    FVolume: Double;
    procedure SetAutoPlay(const Value: Boolean);
    procedure SetControls(const Value: Boolean);
    procedure SetCurrentTime(const Value: Double);
    procedure SetLoop(const Value: Boolean);
    procedure SetMuted(const Value: Boolean);
    procedure SetPlayBackRate(const Value: Double);
    procedure SetPreload(const value: TTMSFNCWXMediaPlayerPreload);
    procedure SetUrl(const Value: string);
    procedure SetVolume(const Value: Double);
    function IsVolumeStored: Boolean;
    function IsPlaybackRateStored: Boolean;
    function IsCurrentTimeStored: Boolean;
  protected
    FURL: string;
    function GetCustomFunctions: string; override;
    procedure CallCustomEvent(AEventData: TTMSFNCCustomWEBControlEventData); override;
    procedure ExecutePreload;
    procedure HandleMediaInitialized; virtual;
    procedure HandleMetaDataLoaded(const Val: string);
    procedure HandleOnPlay;
    procedure HandleOnPause;
    procedure HandleOnEnded;
    procedure HandleOnError(const Val: string);
    procedure HandleOnRateChange(const Val: string);
    procedure HandleOnVolumeChange(const Val: string);
    procedure HandleOnTimeUpdate(const Val: string);
    procedure Initialized; override;
    function GetWaitInitVariables: string; override;
    function GetWaitInitCondition: string; override;
    function GetWaitInitElseStatement: string; override;
    procedure DoControlInitialized; override;
    {$IFDEF WEBLIB}
    procedure UpdateElement; override;
    {$ENDIF}
    procedure ForwardMedia(const Value: Integer);
    procedure Rewind(const Value: Integer);
    property AutoPlay: Boolean read FAutoPlay write SetAutoPlay default False;
    property CurrentTime: Double read FCurrentTime write SetCurrentTime stored IsCurrentTimeStored nodefault;
    property Controls: Boolean read FControls write SetControls default True;
    property Duration: Double read FDuration;
    property IsPlaying: Boolean read FIsPlaying;
    property Loop: Boolean read FLoop write SetLoop default False;
    property Muted: Boolean read FMuted write SetMuted default False;
    property OnPlay: TNotifyEvent read FOnPlay write FOnPlay;
    property OnPause: TNotifyEvent read FOnPause write FOnPause;
    property OnEnded: TNotifyEvent read FOnEnded write FOnEnded;
    property OnError: TTMSFNCWXMediaPlayerErrorEvent read FOnError write FOnError;
    property OnRateChange: TTMSFNCWXMediaPlayerMediaEvent read FOnRateChange write FOnRateChange;
    property OnVolumeChange: TTMSFNCWXMediaPlayerMediaEvent read FOnVolumeChange write FOnVolumeChange;
    property OnTimeUpdate: TTMSFNCWXMediaPlayerMediaEvent read FOnTimeUpdate write FOnTimeUpdate;
    property OnMetaDataLoaded: TTMSFNCWXMediaPlayerMediaEvent read FOnMetaDataLoaded write FOnMetaDataLoaded;
    property PlayBackRate: Double read FPlayBackRate write SetPlayBackRate stored IsPlaybackRateStored nodefault;
    property Preload: TTMSFNCWXMediaPlayerPreload read FPreload write SetPreload default plAuto;
    property URL: string read FURL write SetUrl;
    property Volume: Double read FVolume write SetVolume stored IsVolumeStored nodefault;
  public
    constructor Create(AOwner: TComponent); override;
    procedure Play;
    procedure Pause;
  end;

implementation

uses
  WEBLib.TMSFNCWXMediaPlayer.Consts;

{ TTMSFNCWXCustomMediaPlayer }

procedure TTMSFNCWXCustomMediaPlayer.CallCustomEvent(
  AEventData: TTMSFNCCustomWEBControlEventData);
begin
  inherited;

  if AEventData.EventName <> '' then
  begin
    case IndexStr(AEventData.EventName,[ONMETADATALOAD, ONMEDIASTART, ONMEDIAPAUSE, ONMEDIAENDED, ONMEDIAERROR, ONMEDIARATECHANGE, ONMEDIAVOLUMECHANGE, ONMEDIATIMEUPDATE]) of
      0: HandleMetaDataLoaded(AEventData.customData);
      1: HandleOnPlay;
      2: HandleOnPause;
      3: HandleOnEnded;
      4: HandleOnError(AEventData.CustomData);
      5: HandleOnRateChange(AEventData.CustomData);
      6: HandleOnVolumeChange(AEventData.CustomData);
      7: HandleOnTimeUpdate(AEventData.CustomData);
    end;
  end;
end;

constructor TTMSFNCWXCustomMediaPlayer.Create(AOwner: TComponent);
begin
  inherited;
  FControls := True;
  FAutoPlay := False;
  FLoop := False;
  FMuted := False;
  FVolume := 0.5;
  FPlayBackRate := 1.0;
  FPreload := plAuto;
  LocalFileAccess := True;
end;

procedure TTMSFNCWXCustomMediaPlayer.DoControlInitialized;
begin
  inherited;
  HandleMediaInitialized;
end;

procedure TTMSFNCWXCustomMediaPlayer.ExecutePreload;
var
  s: string;
begin
  case FPreload of
    plNone: s := 'none';
    plMetadata: s := 'metadata';
    plAuto: s := 'auto';
  end;

  ExecuteJavascript(StringReplace(Format(PRELOADMEDIA, [s]), CONTROL_ID,
    GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.ForwardMedia(const Value: Integer);
begin
  ExecuteJavascript(StringReplace(Format(MEDIAFORWARD, [IntToStr(Value)]),
    CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

function TTMSFNCWXCustomMediaPlayer.GetCustomFunctions: string;
begin
  Result := GetWXMediaScript(GetControlID);
end;

function TTMSFNCWXCustomMediaPlayer.GetWaitInitCondition: string;
begin
  Result := '!e';
end;

function TTMSFNCWXCustomMediaPlayer.GetWaitInitElseStatement: string;
begin
  Result := GetWXInitializeMediaScript(GetControlID, GetDefaultEventDataObject);
end;

function TTMSFNCWXCustomMediaPlayer.GetWaitInitVariables: string;
begin
  Result :=  'var e = document.getElementById("' + GetControlID + '");';
end;

procedure TTMSFNCWXCustomMediaPlayer.HandleMediaInitialized;
begin
  ExecutePreload;

  ExecuteJavascript(StringReplace(Format(TOGGLECONTROLS, [BoolToStr(FControls)]),
    CONTROL_ID, GetControlID, [rfReplaceAll]));

  if not (csDesigning in componentstate) then
  begin
    ExecuteJavascript(StringReplace(Format(TOGGLEAUTOPLAY, [BoolToStr(FAutoPlay)]),
      CONTROL_ID, GetControlID, [rfReplaceAll]));
  end;

  ExecuteJavascript(StringReplace(Format(TOGGLEMUTE, [BoolToStr(FMuted)]),
    CONTROL_ID, GetControlID, [rfReplaceAll]));

  ExecuteJavascript(StringReplace(Format(TOGGLELOOP, [BoolToStr(FLoop)]),
    CONTROL_ID, GetControlID, [rfReplaceAll]));

  ExecuteJavascript(StringReplace(Format(MEDIAVOLUME, [FloatToJSValue(FVolume)]),
    CONTROL_ID, GetControlID, [rfReplaceAll]));

  ExecuteJavascript(StringReplace(Format(MEDIAPLAYBACKRATE, [FloatToJSValue(FPlayBackRate)]),
    CONTROL_ID, GetControlID, [rfReplaceAll]));

  ExecuteJavascript(StringReplace(Format(MEDIARESTART, [FloatToStr(FCurrentTime)]),
    CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.HandleMetaDataLoaded(const Val: string);
var
  s: string;
begin
  s := StringReplace(Val, '"', '', [rfReplaceAll]);
  FIsPlaying := False;
  FDuration := JSStringToFloat(s);

  if Assigned(OnMetaDataLoaded) then
    OnMetaDataLoaded(Self, Duration);
end;

procedure TTMSFNCWXCustomMediaPlayer.HandleOnEnded;
begin
  FIsPlaying := False;

  if Assigned(OnEnded) then
    OnEnded(Self);
end;

procedure TTMSFNCWXCustomMediaPlayer.HandleOnError(const Val: string);
var
  err: TTMSFNCWXMediaPlayerMediaError;
begin
  err := TTMSFNCWXMediaPlayerMediaError(StrToInt(StringReplace(Val, '"', '', [rfReplaceAll])) - 1);

  if Assigned(OnError) then
    OnError(Self, err);
end;

procedure TTMSFNCWXCustomMediaPlayer.HandleOnPause;
begin
  FIsPlaying := False;

  if Assigned(OnPause) then
    OnPause(Self);
end;

procedure TTMSFNCWXCustomMediaPlayer.HandleOnPlay;
begin
  FIsPlaying := True;

  if Assigned(OnPlay) then
    OnPlay(Self);
end;

procedure TTMSFNCWXCustomMediaPlayer.HandleOnRateChange(const Val: string);
var
  rate: Double;
begin
  rate := JSStringToFloat(StringReplace(Val, '"', '', [rfReplaceAll]));
  if FPlayBackRate <> rate then
    FPlayBackRate := rate;

  if Assigned(OnRateChange) then
    OnRateChange(Self, rate);
end;

procedure TTMSFNCWXCustomMediaPlayer.HandleOnTimeUpdate(const Val: string);
var
  time: Double;
begin
  time := JSStringToFloat(StringReplace(Val, '"', '', [rfReplaceAll]));

  if FCurrentTime <> time then
     FCurrentTime := time;

  if Assigned(OnTimeUpdate) then
    OnTimeUpdate(Self, time);
end;

procedure TTMSFNCWXCustomMediaPlayer.HandleOnVolumeChange(const Val: string);
var
  vol: Double;
begin
  vol := JSStringToFloat(StringReplace(Val, '"', '', [rfReplaceAll]));
  if FVolume <> vol then
    FVolume := vol;

  if Assigned(OnVolumeChange) then
    OnVolumeChange(Self, vol);
end;

procedure TTMSFNCWXCustomMediaPlayer.Initialized;
begin
  inherited;
  EnableContextMenu := False;
  EnableShowDebugConsole := False;
end;

function TTMSFNCWXCustomMediaPlayer.IsCurrentTimeStored: Boolean;
begin
  Result := FCurrentTime <> 0.0;
end;

function TTMSFNCWXCustomMediaPlayer.IsPlaybackRateStored: Boolean;
begin
  Result := FPlayBackRate <> 1.0;
end;

function TTMSFNCWXCustomMediaPlayer.IsVolumeStored: Boolean;
begin
  Result := FVolume <> 0.5;
end;

procedure TTMSFNCWXCustomMediaPlayer.Pause;
begin
  ExecuteJavascript(StringReplace(PAUSEMEDIA, CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.Play;
begin
  ExecuteJavascript(StringReplace(PLAYMEDIA, CONTROL_ID, GetControlID,[rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.Rewind(const Value: Integer);
begin
  ExecuteJavascript(StringReplace(Format(MEDIAREWIND, [IntToStr(Value)]),
    CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.SetAutoPlay(const Value: Boolean);
begin
  FAutoPlay := Value;

  if ((UpdateCount = 0) and not (csDesigning in componentstate)) then
    ExecuteJavascript(StringReplace(Format(TOGGLEAUTOPLAY,[BoolToStr(FAutoPlay)]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.SetControls(const Value: Boolean);
begin
  FControls := Value;

  if UpdateCount = 0 then
    ExecuteJavascript(StringReplace(Format(TOGGLECONTROLS, [BoolToStr(FControls)]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.SetCurrentTime(const Value: Double);
begin
  FCurrentTime := value;

  if UpdateCount = 0 then
    ExecuteJavascript(StringReplace(Format(MEDIARESTART, [FloatToStr(FCurrentTime)]), CONTROL_ID, GetControlID,[rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.SetLoop(const Value: Boolean);
begin
  FLoop := Value;

  if UpdateCount = 0 then
    ExecuteJavascript(StringReplace(Format(TOGGLELOOP, [BoolToStr(FLoop)]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.SetMuted(const Value: Boolean);
begin
  FMuted := Value;

  if UpdateCount = 0 then
    ExecuteJavascript(StringReplace(Format(TOGGLEMUTE, [BoolToStr(FMuted)]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.SetPlayBackRate(const Value: Double);
begin
  FPlayBackRate := value;

  if UpdateCount = 0 then
    ExecuteJavascript(StringReplace(Format(MEDIAPLAYBACKRATE, [FloatToJSValue(FPlayBackRate)]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.SetPreload(
  const value: TTMSFNCWXMediaPlayerPreload);
begin
  FPreload := Value;

  if UpdateCount = 0 then
    ExecutePreload;
end;

procedure TTMSFNCWXCustomMediaPlayer.SetUrl(const Value: string);
begin
  FURL := Value;

  if UpdateCount = 0 then
    ExecuteJavascript(StringReplace(Format(MEDIASOURCE, [FURL]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomMediaPlayer.SetVolume(const Value: Double);
begin
  FVolume := Value;

  if UpdateCount = 0 then
    ExecuteJavascript(StringReplace(Format(MEDIAVOLUME, [FloatToJSValue(FVolume)]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

{$IFDEF WEBLIB}
procedure TTMSFNCWXCustomMediaPlayer.UpdateElement;
begin
  inherited;
  if Assigned(ElementHandle) then
  begin
    ElementHandle.style.removeProperty('overflow');
    ElementHandle.style.setProperty('overflow', 'none');
  end;
end;
{$ENDIF}

end.
